document.addEventListener("DOMContentLoaded", function () {
  
    function scrollToCircle() {
        const position = localStorage.getItem("position-circle");
        if (!position) return;

        window.scrollTo(0, parseInt(position));
        localStorage.removeItem("position-circle");
    }

    const collectionCircles = document.querySelectorAll(".list-collection__item");
    collectionCircles.forEach(circle => 
        circle.addEventListener("click", (event) => handleRedirect(event, circle))
    );

    function savePosition() {
        const currentPosition = window.scrollY;
        localStorage.setItem("position-circle", currentPosition);
    }

    function handleRedirect(event, circle) {
        event.preventDefault();
        savePosition();
        const href = circle.getAttribute("href");
        window.location.href = href;
    }

    scrollToCircle();
});
